import { createContext, useContext, useState } from "react";

// Create Context
const PRBottlerSelectionContext = createContext();

// Context Provider Component
export const PRBottlerSelectionProvider = ({ children }) => {
    const [selectedData, setSelectedData] = useState([]);

    return (
        <PRBottlerSelectionContext.Provider value={{ selectedData, setSelectedData }}>
            {children}
        </PRBottlerSelectionContext.Provider>
    );
};

// Custom Hook for easy access
export const usePRBottlerSelection = () => useContext(PRBottlerSelectionContext);
